// Información de contacto centralizada para toda la aplicación
export const CONTACT_INFO = {
  phones: [
    {
      number: "+56 9 9318 5038",
      label: "Whatsapp",
      primary: false,
      whatsapp: true,
    },
    {
      number: "800 123 990",
      label: "Contacto Venta Usados Fijo",
      primary: false,
      whatsapp: false,
    },
  ],
  emails: [
    {
      email: "ventausados@tattersall.cl",
      label: "Consultas Generales",
      primary: true,
    },
  ],
  whatsapp: {
    primary: "+56 9 9318 5038",
    message: "Hola, me gustaría consultar sobre una cotización",
  },
  schedule: {
    weekdays: "Lunes a jueves de 8:30 a 18:00 hrs",
    friday: "Viernes de 8:30 a 17:00 hrs",
    weekend: "Sábados y domingos cerrados",
  },
  social: {
    website: "https://ventausados.tattersall.cl",
    facebook: "https://www.facebook.com/profile.php?id=61582645560477",
    instagram: "https://www.instagram.com/tattersall_ventausados/",
    tiktok: "https://www.tiktok.com/@tattersall_ventausados",
  },
};

// Función para obtener el teléfono principal
export const getPrimaryPhone = () => {
  return (
    CONTACT_INFO.phones.find((phone) => phone.primary)?.number ||
    CONTACT_INFO.phones[0].number
  );
};

// Función para obtener el WhatsApp principal
export const getPrimaryWhatsApp = () => {
  return CONTACT_INFO.whatsapp.primary;
};

// Función para obtener el email principal
export const getPrimaryEmail = () => {
  return (
    CONTACT_INFO.emails.find((email) => email.primary)?.email ||
    CONTACT_INFO.emails[0].email
  );
};

// Función para generar URL de WhatsApp con mensaje personalizado
export const getWhatsAppURL = (customMessage = null, quoteId = null) => {
  const phone = getPrimaryWhatsApp().replace(/[\s+]/g, "");
  let message = customMessage || CONTACT_INFO.whatsapp.message;

  if (quoteId) {
    message = `${quoteId} - ${message}`;
  }

  const encodedMessage = encodeURIComponent(message);
  return `https://wa.me/${phone}?text=${encodedMessage}`;
};

// Función para generar URL de email con asunto personalizado
export const getEmailURL = (subject = null, quoteId = null) => {
  const email = getPrimaryEmail();
  let emailSubject = subject || "Consulta sobre cotización";

  if (quoteId) {
    emailSubject = `Consulta sobre cotización ${quoteId}`;
  }

  const encodedSubject = encodeURIComponent(emailSubject);
  return `mailto:${email}?subject=${encodedSubject}`;
};
